import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQSectionProps {
  items: FAQItem[];
}
export function FAQSection({
  items
}: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-4 max-w-3xl mx-auto font-['Inter']" data-id="element-1">
      {items.map((item, index) => <div key={index} className="border border-stone-200 rounded-2xl bg-white overflow-hidden shadow-sm transition-all duration-300 hover:border-[#3D5A3D]/30" data-id="element-2">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-3">
            <span className="font-['Inter'] font-bold text-[#1A1A1A] pr-4 text-lg" data-id="element-4">
              {item.question}
            </span>
            <div className={`w-8 h-8 rounded-full flex items-center justify-center bg-[#FAFAF8] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180 bg-[#3D5A3D]/10' : ''}`} data-id="element-5">
              <ChevronDown className={`w-5 h-5 ${openIndex === index ? 'text-[#3D5A3D]' : 'text-stone-400'}`} data-id="element-6" />
            </div>
          </button>
          <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-7">
            <p className="text-[#4A4A4A] leading-relaxed border-t border-stone-100 pt-4" data-id="element-8">
              {item.answer}
            </p>
          </div>
        </div>)}
    </div>;
}